import React from 'react';
import ElectricityCharts from './charts/ElectricityCharts';
import RankBox from './RankBox';
import { electricityPrice, electricityRank } from './api/rankBoxes';

const ElectricityView = () => {
  return (
    <div className="container mx-auto px-4">
      <div className="flex flex-wrap justify-center">
        <RankBox
          title="Electricity Price"
          value={electricityPrice?.value || 0}
          type="currency"
          rank={electricityRank?.value}
          trend={electricityPrice?.trend}
        />
      </div>
      <div className="bg-white rounded-lg shadow p-6 mt-4">
        <ElectricityCharts />
      </div>
    </div>
  );
};

export default ElectricityView;
